const announcementCurrency = document.querySelector('.announcement-bar__message--currency');  
const shopifyCountry = Shopify.country;
let freeShippingAmount;
if (shopifyCountry === 'AU') {
    freeShippingAmount = document.querySelector('.free_shipping--amount-special.AU').textContent;
} else if (shopifyCountry === 'CA') {
    freeShippingAmount = document.querySelector('.free_shipping--amount-special.CA').textContent;
} else if (shopifyCountry === 'CN') {
    freeShippingAmount = document.querySelector('.free_shipping--amount-special.CN').textContent;
} else if (shopifyCountry === 'CO') {
    freeShippingAmount = document.querySelector('.free_shipping--amount-special.CO').textContent;
} else if (shopifyCountry === 'HK') {
    freeShippingAmount = document.querySelector('.free_shipping--amount-special.HK').textContent;
} else if (shopifyCountry === 'MX') {
    freeShippingAmount = document.querySelector('.free_shipping--amount-special.MX').textContent;
} else if (shopifyCountry === 'NZ') {
    freeShippingAmount = document.querySelector('.free_shipping--amount-special.NZ').textContent;
} else if (shopifyCountry === 'TW') {
    freeShippingAmount = document.querySelector('.free_shipping--amount-special.TW').textContent;
} else if (shopifyCountry === 'TR') {
    freeShippingAmount = document.querySelector('.free_shipping--amount-special.TR').textContent;
} else {
    freeShippingAmount = document.querySelector('.free_shipping--amount').textContent;
}

var freeShippingAmountBar = document.querySelector('.new-announcement-bar');
var free_shipping_threshold_currency = freeShippingAmount * Shopify.currency.rate;
var free_shipping_threshold_currency_format = formatWithDelimiters(free_shipping_threshold_currency, 0).split(',').join('') * 100;
var free_shipping_amount_s = Shopify.formatMoney(free_shipping_threshold_currency_format, Shopify.money_format);
if(free_shipping_threshold_currency) {
    announcementCurrency.innerHTML = free_shipping_amount_s;
    freeShippingAmountBar.style.display = "block";
} 


document.addEventListener('DOMContentLoaded', function() {
    const announcementBar = document.querySelector('.new-announcement-bar');
    const mainElement = document.querySelector('main');

    if (announcementBar.style.display === 'block') {
        mainElement.classList.add('main__announcement-bar');
    }
});